import React, { useEffect, useRef, useState } from 'react'

export default function ConfirmDialog({ onCancel, onConfirm, title, heading, open, children, type, options, layout }) {
    const [show, setShow] = useState(false)
    const yesRef = useRef()
    useEffect(() => {
        setShow(open)
    }, [open])
    useEffect(() => {
        if (show && yesRef.current) yesRef.current.focus()
    }, [show])
    const _handleClicked = (b) => {
        if (b) {
            if (onConfirm()) { setShow(false) }
        }
        else {
            onCancel()
            setShow(false)
        }
    }
    if (!show) return <></>
    return (
        <div className='position-absolute d-flex align-items-center justify-content-center text-center' style={{
            // background: 'rgba(0,0,0,0.7)',
            top: '0px'
            , bottom: '0px'
            , left: '0px'
            , right: '0px'
            , zIndex: 10999
        }}>
            <div
                style={{ maxHeight: '80vh', minHeight: layout && layout === 'beeeg' && '80vh', minWidth: layout && layout === 'beeeg' && '80vw' }}
                className='bg-primary-container text-white text-dark p-3 rounded shadow'>
                {heading ? <h3>{heading}</h3> : title ? <h3>Confirm</h3> : <></>}
                <div className={` h-50 ${layout && layout !== 'beeeg' && 'bg-secondary-container'} p-2 rounded`}
                    style={{ overflow: 'auto', maxHeight: 'calc(80vh - 200px)', minWidth: layout && layout === 'beeeg' && '75vw', minHeight: layout && layout === 'beeeg' && 'calc(80vh - 135px)' }}>
                    <p>{children}</p>
                </div>
                <div className='mt-2'>
                    {
                        options ? <>
                            {options.cancel && <button onClick={() => _handleClicked(false)} className='btn m-2 shadow'>{options.cancel}</button>}
                            {options.confirm && <button ref={yesRef} onClick={onConfirm ? () => _handleClicked(true) : undefined} className={`btn m-2 shadow ${!onConfirm ? 'disabled' : ''}`}>{options.confirm}</button>}
                        </>
                            :
                            <>
                                <button onClick={() => _handleClicked(false)} className='btn m-2 shadow'>{type && type === 'Accept' ? 'Decline' : 'No'}</button>
                                <button ref={yesRef} onClick={onConfirm ? () => _handleClicked(true) : undefined} className={`btn m-2 shadow ${!onConfirm ? 'disabled' : ''}`}>{type && type === 'Accept' ? 'Done' : 'Yes'}</button>
                            </>
                    }

                </div>
            </div>
        </div >
    )
}
